export default function ExternalResourcesController(
  $scope,
) {
  const vm = this;
  _activate();
  /** *********************************************
   * Event Handlers
   */
  function _activate() {
    $scope.$on('refreshOtherResourcesStatus', (event, opt) => {
      vm.status.otherResourcesStatus = opt.status;
    });
  }
  /** *********************************************
   * Private Functions
   */
}

ExternalResourcesController.$inject = [
  '$scope',
];
